import React from 'react';
import { ISectionLoaderProps } from './SectionLoader.types';
import { useSectionLoaderStyles } from './SectionLoader.styles';
import { LoadingStates } from '../..';
import { SectionError } from '../SectionError/SectionError';
import { Spinner } from '@fluentui/react-components';
import { genericErrorMessage } from '../../Constants';

export const SectionLoader = (props: ISectionLoaderProps) => {
  const { state, announce } = props;
  const label = props.label || 'Loading...';

  const styles = useSectionLoaderStyles();
  const [message, setMessage] = React.useState('');
  const shimmerContent: JSX.Element | JSX.Element[] = props.shimmerComponent ?? (
    <div className={styles.container}>
      <Spinner size="small" appearance="primary" className={styles.loader} label={label} labelPosition="after" />
    </div>
  );

  React.useEffect(() => {
    if (!announce) return;
    let announceText = '';
    switch (state) {
      case LoadingStates.STARTED:
        announceText = label;
        break;
      case LoadingStates.SUCCEEDED:
        announceText = 'loading complete';
        break;
      case LoadingStates.FAILED:
        announceText = `${props.error?.title || genericErrorMessage} ${props.error?.description}`;
        break;
    }
    setMessage(announceText);
    // Clearing message to stop focusing on hidden content in screen reader mode
    // https://microsoftit.visualstudio.com/OneITVSO/_workitems/edit/8659552
    if (announceText) {
      setTimeout(() => {
        setMessage('');
      }, 200);
    }
  }, [state, announce, label, props.error?.title, props.error?.description]);

  const errorComponent = props.errorComponent ?? <SectionError {...props.error} />;

  return (
    <>
      <div role="status" aria-live="assertive" className={styles.srOnly}>
        {message}
      </div>
      {state === LoadingStates.STARTED && shimmerContent}
      {state === LoadingStates.FAILED && errorComponent}
      {state === LoadingStates.SUCCEEDED && props.children}
    </>
  );
};
